module.exports = __webpack_public_path__ + "static/media/markerHome.c4b00773.svg";